import React from 'react';
import {MDBCard, MDBCardBody, MDBRadio, MDBValidation,} from 'mdb-react-ui-kit';
import Box from "@mui/material/Box";
import {Button} from "@mui/material";

const PayMethod = (props) => {
    var delivery=JSON.parse(localStorage.getItem('delivery'))
    var payMethod=JSON.parse(localStorage.getItem('payMethod'))

    const [payMethType, setpayMethType]= React.useState(payMethod.Type);
    const [pay, setpay]= React.useState(payMethod);


    let pay_pol= <></>



    const onChange = (e: any) => {
        payMethod.Type=e.target.id
        localStorage.setItem('payMethod',JSON.stringify(payMethod));
        payMethod=JSON.parse(localStorage.getItem('payMethod'))
        setpay(payMethod)
    };
    if (delivery.Type=="Самовывоз"){
        pay_pol= <MDBRadio
            label='Наличными при получении'
            checked={pay.Type === 'Наличными при получении'}
            onChange={onChange}
            required
            id='Наличными при получении'
            name='radio-stacked' />
    }
    return (
        <>
        <MDBCard>
            <MDBCardBody>
        <MDBValidation isValidated>
            {pay_pol}
            <MDBRadio
                    label='Перевод на карту'
                    required
                    checked={pay.Type === 'Перевод на карту'}
                    onChange={onChange}
                    id='Перевод на карту'
                    name='radio-stacked'
                />
            <MDBRadio
                label='Оплата в сервисе Robokassa'
                required
                checked={pay.Type === 'Оплата в сервисе Robokassa'}
                onChange={onChange}
                id='Оплата в сервисе Robokassa'
                name='radio-stacked'
            />
        </MDBValidation>

                    </MDBCardBody>
                        </MDBCard>

            <Box sx={{ mb: 2 }}>
                <div>

                    <Button
                        variant="contained"
                        onClick={props.callNext}
                        sx={{ mt: 1, mr: 1 }}
                    >
                        Перейти к контактам
                    </Button>
                    <Button
                        variant="contained"
                        onClick={props.callBackX}
                        sx={{ mt: 1, mr: 1 }}
                    >
                        Назад
                    </Button>

                </div>
            </Box>
        </>

    );
};

export default PayMethod;